/* Enhance legacy policy markup; all policy wording and links stay intact. */
(() => {
  const root = document.querySelector('.shopify-policy__body .rte');
  if (!root || root.dataset.fsgbFormatted || !/^ja(?:-|$)/i.test(document.documentElement.lang)) return;
  const legal = location.pathname.endsWith('/policies/legal-notice');
  const labels = ['販売業者','代表責任者','所在地','メールアドレス','商品の販売価格','商品代金以外の必要料金','支払い方法','お支払い時期','商品の引渡時期','返品期限・条件','返品送料'];
  const original = root.textContent.replace(/\s/g, '');
  const output = document.createDocumentFragment();
  let copy = output;
  let count = 0;
  function heading(fragment) {
    const section = document.createElement('section');
    section.className = 'fsgb-policy-section';
    const title = document.createElement('h2');
    title.append(fragment);
    copy = document.createElement('div');
    copy.className = 'fsgb-policy-copy';
    section.append(title, copy); output.append(section); count++;
  }
  function paragraph(fragment) {
    if (!fragment.textContent.trim()) return;
    const p = document.createElement('p'); p.append(fragment); copy.append(p);
  }
  function splitAt(fragment, offset) {
    const holder = document.createElement('div'); holder.append(fragment);
    const walker = document.createTreeWalker(holder, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (offset <= node.length) {
        const range = document.createRange(); range.selectNodeContents(holder);
        range.setEnd(node, offset);
        const lead = range.extractContents();
        const rest = document.createDocumentFragment(); rest.append(...holder.childNodes);
        return [lead, rest];
      }
      offset -= node.length;
    }
    return [document.createDocumentFragment(), holder];
  }
  for (const child of root.childNodes) {
    if (child.nodeType !== Node.ELEMENT_NODE || child.tagName !== 'P') {
      output.append(child.cloneNode(true)); continue;
    }
    const breaks = [...child.querySelectorAll('br')];
    let previous = null;
    for (const boundary of [...breaks, null]) {
      const range = document.createRange(); range.selectNodeContents(child);
      if (previous) range.setStartAfter(previous);
      if (boundary) range.setEndBefore(boundary);
      const line = range.cloneContents();
      const text = line.textContent;
      if (legal) {
        const label = labels.find(label => text.trimStart().startsWith(label + '：'));
        if (label) {
          const end = text.indexOf('：') + 1;
          const [lead, rest] = splitAt(line, end);
          heading(lead); paragraph(rest);
        } else paragraph(line);
      } else if (/^\s*第[0-9０-９]+条\s*[（(].+[）)]\s*$/.test(text)) heading(line);
      else paragraph(line);
      previous = boundary;
    }
  }
  // Fail safely if unfamiliar markup would change any visible policy wording.
  if (!count || output.textContent.replace(/\s/g, '') !== original) return;
  root.replaceChildren(output); root.dataset.fsgbFormatted = 'true';
  if (legal) root.classList.add('fsgb-policy-legal');
})();
